import { OverlayType } from '../../constants/common'
import { SMAConfig } from './sma'

export class SMA2Config extends SMAConfig {
  static type = OverlayType.Sma2
}
